import Vue from 'vue';
import Vuetify from 'vuetify';
import colors from 'vuetify/lib/util/colors'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        // dark: true,
        themes: {
            light: {
                // primary: colors.indigo.base,
                primary: colors.blue.darken3,
                appbar: colors.indigo.base,
                accent: colors.indigo.accent2,          
                background: "#F9F9F9",
                navbarGrey: "#F2F2F2",
                // customAccent: colors.green.base // Es necesario cuando el background es light
                // para que se aplique el color del texto correcto debido a que cualquier color "primary"
                // si no se especifica dark el text color siempre sera white
                verde: colors.green.base
            },
            dark: {
                primary: colors.indigo.base,
                // appbar: colors.grey.darken4
            }
        }
    },
    icons: {
        iconfont: "mdi"
    }
});

const minsaTheme = {
    dark: false,
    themes: {
        light: {
            primary: colors.green.base,
            appbar: colors.yellow.darken1,
            accent: colors.yellow.base,
            accentGreen: colors.green.accent3
            // customAccent: colors.green.base // Es necesario cuando el background es light
            // para que se aplique el color del texto correcto debido a que cualquier color "primary"
            // si no se especifica dark el text color siempre sera white
        },
        dark: {
            primary: colors.orange.base,
            appbar: colors.grey.darken4
        }
    }
}
